export enum EEIdIconType {
  BankId = 'BankId',
  BankIdNo = 'BankIdNo',
  NemId = 'NemId',
  NemIdOrg = 'NemIdOrg',
  MitIdDark = 'MitIdDark',
}
